import React, { useState } from "react";
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import "./ContactForm.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: ""
  });

  const [errors, setErrors] = useState({});

  // Validation patterns and custom error messages
  const validationRules = {
    firstName: {
      pattern: /^[A-Za-z]+$/,
      errorMessage: "First Name should contain only letters."
    },
    lastName: {
      pattern: /^[A-Za-z]+$/,
      errorMessage: "Last Name should contain only letters."
    },
    email: {
      pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
      errorMessage: "Please enter a valid email address."
    },
    phone: {
      pattern: /^[0-9]{10}$/,
      errorMessage: "Phone number should be exactly 10 digits."
    },
    message: {
      pattern: /^.+$/,
      errorMessage: "Message cannot be empty."
    }
  };

  // Handle form change and validation
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });

    // Validate the field and set the error message
    const rule = validationRules[id];
    if (!rule.pattern.test(value)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [id]: rule.errorMessage
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [id]: null
      }));
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        {/* Contact Info Section */}
        <div className="contact-info-form">
          <h2>Reach Out to Our Dedicated Support Team</h2>
          <p className="contact-p">Our team is ready to help. Your satisfaction is our priority.</p>
          <p className="contact-info-detail-p">
            Got a question, need advice, or looking for help? Our knowledgeable
            team is here to assist you every step of the way. We’re just a
            message or call away, ready to provide the guidance you need.
          </p>
          <div className="contact-details-form">
            <div className="contact-item">
              <div className="contact-icon">
                <FaEnvelope className="icon-contact-form" />
              </div>
              <div className="contact-text">
                <p><strong>Email Address:</strong></p>
                <p> info@waisan.in </p>
              </div>
            </div>
            <hr />
            <div className="contact-item">
              <div className="contact-icon">
                <FaPhoneAlt className="icon-contact-form" />
              </div>
              <div className="contact-text">
                <p><strong>Phone Number:</strong></p>
                <p>+91 9175 917553</p>
              </div>
            </div>
            <hr />
            <div className="contact-item">
              <div className="contact-icon">
                <FaMapMarkerAlt className="icon-contact-form" />
              </div>
              <div className="contact-text">
                <p><strong>Our Location:</strong></p>
                <p>A2-414 Mangalmurti CHS, behind Kale Motor Driving School, besides
                  Kanchan Heights Prestige Showroom, Sinhgad Road, Pune - 411030
                </p>
              </div>
            </div>
            <hr />
          </div>
        </div>

        {/* Contact Form Section */}
        <div className="contact-form">
          <h3>Get in Touch</h3>
          <p>How we can help you? Please write down your query</p>
          <form
            action="https://formsubmit.co/info@waisan.in"
            method="POST"
          >
            <div className="form-group">
              <div className="input-field">
                <label htmlFor="firstName">First Name *</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
                {errors.firstName && <p className="error">{errors.firstName}</p>}
              </div>
              <div className="input-field">
                <label htmlFor="lastName">Last Name *</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
                {errors.lastName && <p className="error">{errors.lastName}</p>}
              </div>
            </div>
            <div className="form-group">
              <div className="input-field">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                {errors.email && <p className="error">{errors.email}</p>}
              </div>
            </div>
            <div className="form-group">
              <div className="input-field">
                <label htmlFor="phone">Phone *</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
                {errors.phone && <p className="error">{errors.phone}</p>}
              </div>
            </div>
            <div className="input-field">
              <label htmlFor="message">Message *</label>
              <textarea
                id="message"
                name="message"
                rows="3"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
              {errors.message && <p className="error">{errors.message}</p>}
            </div>
            <button type="submit" disabled={Object.values(errors).some((err) => err)}>
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
